import { TastierGlobal } from "@/portal/globalAccess";

export class AvatarPicker {
    private $element?: JQuery;
    private ktElement: any;

    constructor($element?: JQuery) {
        if ($element === undefined) {
            //todo create picker in memory dom
        } else {
            this.$element = $element;
        }

        this.ktElement = TastierGlobal.getKTAvatar(this.$element![0]);
    }

    public getValue(): File | undefined {
        const file = this.ktElement.input.files[0];

        if (file === undefined) return undefined;

        if (!file.type.includes("image")) return undefined;

        return file;
    }

    public setValue(value?: string): AvatarPicker {
        this.ktElement.input.value = "";
        $(this.ktElement.element).removeClass("kt-avatar--changed");

        if (value === undefined) this.$element!.find("> .kt-avatar__holder").removeAttr("style");
        else
            this.$element!.find("> .kt-avatar__holder").css(
                "background-image",
                "url('" + value + "?t=" + new Date().getTime() + "')"
            );

        return this;
    }

    public renderTo($element: JQuery): AvatarPicker {
        this.$element!.appendTo($element);

        return this;
    }

    public static createFromFormCtrl($formControl: JQuery): AvatarPicker {
        return new AvatarPicker($formControl);
    }
}
